<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать акцию</strong>
                </CCardHeader>
                <CCardBody>
                    <PromotionsUpsertForm
                        @success="$router.push(`/promotions`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import PromotionsUpsertForm from '@/components/promotions/PromotionsUpsertForm';

    export default {
        name: 'PromotionsCreate',

        components: {
            PromotionsUpsertForm
        },
    };
</script>
